import { post } from '@rails/request.js'

window['wizard_settings#index'] = (function () {
  let handler = null

  return function () {
    if (handler) document.removeEventListener('change', handler)

    handler = async function (e) {
      const input = e.target.closest('input#company_talent_pool_agreement')
      if (!input) return

      const form = input.closest('form')
      const previousValue = !input.checked

      input.disabled = true

      const formData = new FormData(form)
      formData.set(input.name, input.checked)

      try {
        const response = await post(form.action, {
          body: formData,
          responseKind: 'script'
        })

        if (!response.ok) {
          input.checked = previousValue
        }
      } catch {
        input.checked = previousValue
      } finally {
        input.disabled = false
      }
    }

    document.addEventListener('change', handler)
  }
}())
